const PERSONAL_SCOPE_ID = 'personal'
const ORGANIZATION_SCOPE_PREFIX = 'org:'

function normalizeSearch(search: string): string {
  return search.startsWith('?') ? search.slice(1) : search
}

export function getInitialScopeIdFromSearch(search: string): string {
  const params = new URLSearchParams(normalizeSearch(search))
  const scope = params.get('scope')?.trim()
  const orgId = params.get('orgId')?.trim()

  if (scope === 'organization' && orgId) {
    return `${ORGANIZATION_SCOPE_PREFIX}${orgId}`
  }

  return PERSONAL_SCOPE_ID
}

export function buildEquabotzSettingsSearch(search: string, orgId?: string): string {
  const params = new URLSearchParams(normalizeSearch(search))

  if (orgId?.trim()) {
    params.set('scope', 'organization')
    params.set('orgId', orgId.trim())
  }

  const next = params.toString()
  return next ? `?${next}` : ''
}

export function isOrganizationScopeId(scopeId: string): boolean {
  return scopeId.startsWith(ORGANIZATION_SCOPE_PREFIX)
}
